export default __webpack_public_path__ + "static/media/bloodlevel.c26d7ae9.jpg";